
export class CompanyModel {
    companyId: number;
    companyCode: string;
    companyName: string;
    address: string;
    username: string;

    constructor(companyId: number, companyCode: string, companyName: string, address: string,  username: string) {
        this.companyId = companyId;
        this.companyCode = companyCode;
        this.companyName = companyName;
        this.address = address;
        this.username = username;
    }
}
